import React, { Component } from 'react'

class AppHomeComponent extends Component {
	render() {
		return (
			<h1>Welkom bij CAMS</h1>
		)
	}
}

export default AppHomeComponent;


// WEBPACK FOOTER //
// ./src/application/components/home.js